<template>
  <div>
    <b-modal
      v-model="isModal"
      id="modal-discount"
      body-class="p-0"
      hide-header
      hide-footer
      size="lg"
    >
      <div class="modal-discount">
        <b-row v-if="selectType.id != 4">
          <b-col cols="6">
            <strong>Discount</strong>
            <b-form-input
              v-model="data.discountValue"
              class="mt-2"
              :class="$v.data.discountValue.$error && 'border-red'"
              placeholder="0.00"
              type="number"
              step="any"
            ></b-form-input>
            <p class="m-0 text-error" v-if="$v.data.discountValue.$error">
              Please select value.
            </p>
          </b-col>
          <b-col cols="6">
            <InputSelect
              v-model="data.discountType"
              :options="options"
              title="รูปแบบเงื่อนไข"
              valueField="id"
              textField="name"
              :isValidate="$v.data.discountType.$error"
              :v="$v.data.discountType"
              @onDataChange="onDataChange"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mb-2" cols="12">
            <div class="header-table">
              <div class="w-100">
                <!-- <AutoComplete
                  ref="autocomplete"
                  v-model="selectProductId"
                  id="eventId"
                  label="Product"
                  placeholder="Product"
                  dataListID="productName"
                  name="productName"
                  valueField="productId"
                  showValue=""
                  :optionsList="optionsEvent"
                  @input="handleInput"
                /> -->
                <AutocompleteCustom
                  v-model="selectProductId"
                  ref="autocomplete"
                  id="eventId"
                  label="Product"
                  placeholder="Product"
                  dataListID="productName"
                  name="productName"
                  valueField="productId"
                  showValue=""
                  :optionsList="optionsEvent"
                  @handleInput="handleInput"
                  absolute
                />
              </div>
              <b-button class="btn-filter add" @click="addProduct">
                Add
              </b-button>
            </div>
          </b-col>
          <b-col cols="12">
            <TableConditionDicount
              :items="data.promocodeProductGroup.listItem"
              :fields="isDicount ? fieldsTrue : fieldsFalse"
              :isBusy="isBusy"
              :rows="rows"
              :filter="filter"
              :pageOptions="pageOptions"
              @removeItem="removeItem"
              :v="$v"
            />
            <p
              class="m-0 mb-2 text-error"
              v-if="$v.data.promocodeProductGroup.listItem.$error"
            >
              Please select product
            </p>
          </b-col>
        </b-row>
        <div class="footer-modal">
          <b-button class="btn-filter" @click="closeModal">Cancel</b-button>
          <div class="mx-2"></div>
          <b-button class="btn-filter gold" @click="addAllProductDiscount">
            Add
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { required, requiredIf, minValue } from "vuelidate/lib/validators";
import TableConditionDicount from "../table/TableConditionDicount.vue";
import AutocompleteCustom from "@/components/inputs/AutocompleteCustom";

export default {
  components: {
    TableConditionDicount,
    AutocompleteCustom,
  },
  props: {
    options: {
      type: Array,
      default: [],
    },
    eventId: {
      type: Number,
      default: 0,
    },
    eventIdNew: {
      type: Number,
      default: 0,
    },
    idNew: {
      type: Number,
      default: 0,
    },
    isDicount: {
      type: Boolean,
      default: false,
    },
    selectType: {
      type: Object,
      default: "",
    },
    editDataDiscount: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      isModal: false,

      data: {
        id: 0,
        discountType: null,
        discountValue: null,
        discountProductGroupId: 0,
        isApplyDiscountUsed: false,
        promocodeId: 0,
        isDelete: 0,
        isLoopDiscount: false,
        promocodeProductGroup: {
          id: 0,
          productType: "PRODUCT",
          operation: "IN",
          orderCondition: 1,
          listItem: [],
        },
      },

      optionsEvent: [],
      form: {
        eventId: 0,
        keyword: "",
      },

      selectProductId: null,
      selectProduct: null,

      //   state table condition
      items: [],
      rows: 0,
      filter: {
        filter: null,
        keyword: "",
        skip: 1,
        take: 10,
        page: 1,
      },
      fieldsFalse: [
        {
          key: "productId",
          label: "ID",
          class: "w-50px text-nowrap",
        },
        {
          key: "productName",
          label: "Product Name",
          class: "w-50px text-nowrap",
        },
        {
          key: "eventName",
          label: "Event Name",
          class: "w-50px text-nowrap",
        },
        { key: "actions", label: "Action", class: "w-50px text-nowrap" },
      ],
      fieldsTrue: [
        {
          key: "productId",
          label: "ID",
          class: "w-50px text-nowrap",
        },
        {
          key: "productName",
          label: "Product Name",
          class: "w-50px text-nowrap",
        },
        {
          key: "eventName",
          label: "Event Name",
          class: "w-50px text-nowrap",
        },
        {
          key: "quantity",
          label: "Quantity",
          class: "w-50px text-nowrap",
        },
        { key: "actions", label: "Action", class: "w-50px text-nowrap" },
      ],
      isBusy: false,
      pageOptions: [
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],

      // delay
      isDelay: null,
    };
  },
  validations() {
    return {
      data: {
        discountType: { required },
        discountValue: { required },
        promocodeProductGroup: {
          listItem: {
            required,
            $each: {
              quantity: {
                required,
                minValue: minValue(1),
              },
            },
          },
        },
      },
    };
  },

  watch: {
    isModal(val) {
      if (!val) {
        this.clearData();
      } else {
        this.form = {
          eventId: this.eventId == 1 ? this.eventIdNew : 0,
          keyword: "",
        };
        this.getOptionProductPromocodeDetail();
      }
    },
  },

  methods: {
    async getOptionProductPromocodeDetail() {
      const getData =
        await this.$services.master.getOptionProductPromocodeDetail(
          this.$route.params.id,
          this.form
        );

      if (getData.result == 1) {
        this.optionsEvent = getData.detail.map((x) => {
          x.name = `${x.eventName} - ${x.productName}`;

          return x;
        });
      }
    },
    addProduct() {
      const getValue = this.$refs.autocomplete.selectData;

      if (!getValue) {
        return;
      }

      let find = this.optionsEvent.find(
        (x) => x.productId == getValue.productId
      );
      find.order = 1;
      this.selectProduct = find;

      let checkDupicate = this.data.promocodeProductGroup.listItem.some(
        (x) => x.productId == this.selectProduct.productId
      );

      // default quantity
      this.selectProduct.quantity = 1;

      if (this.selectProduct && !checkDupicate) {
        this.data.promocodeProductGroup.listItem.push(this.selectProduct);
        this.selectProduct = null;
      }

      this.$refs.autocomplete.clearInput();

      this.form.keyword = "";
      this.getOptionProductPromocodeDetail();
    },
    handleInput(val) {
      const isCondition = Number(val) ? true : false;

      if (isCondition) {
        return;
        // let find = this.optionsEvent.find((x) => x.productId == val);
        // find.order = 1;
        // this.selectProduct = find;
      }

      if (this.isDelay) {
        clearTimeout(this.isDelay);
      }

      this.isDelay = setTimeout(() => {
        this.form = {
          eventId: this.eventId == 1 ? this.eventIdNew : 0,
          keyword: val,
        };
        this.getOptionProductPromocodeDetail();
      }, 500);
    },
    removeItem(obj) {
      this.data.promocodeProductGroup.listItem =
        this.data.promocodeProductGroup.listItem.filter((x) => {
          return x.productId != obj.productId;
        });
    },
    addAllProductDiscount() {
      if (this.selectType.id == 4) {
        this.data.discountValue = 1;
        this.data.discountType = 3;

        this.data.discountTypeName = "pcs";
      }

      this.$v.data.$touch();

      if (this.$v.data.$error) {
        return;
      }

      let finalText = [];

      this.data.promocodeProductGroup.listItem.forEach((x) => {
        finalText.push(x.productName);
      });

      finalText = finalText.join(" , ");

      this.data.discountName = finalText;

      //  add new data

      if (this.data.id == 0) {
        this.data.id = `new${this.idNew}`;
      }

      this.$emit("addAllProductDiscount", this.data);

      this.closeModal();
    },
    onDataChange(val) {
      const find = this.options.find((x) => x.id == val);
      this.data.discountTypeName = find.name;
    },
    closeModal() {
      this.clearData();
      this.$bvModal.hide("modal-discount");
    },
    convertDataEdit() {
      this.data = this.editDataDiscount;
    },
    clearData() {
      this.data = {
        id: 0,
        discountType: null,
        discountValue: null,
        discountProductGroupId: 0,
        isApplyDiscountUsed: false,
        promocodeId: 0,
        isDelete: 0,
        isLoopDiscount: false,
        promocodeProductGroup: {
          id: 0,
          productType: "PRODUCT",
          operation: "IN",
          orderCondition: 1,
          listItem: [],
        },
      };

      this.$v.data.$reset();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-discount {
  padding: 20px;

  .header-table {
    display: flex;
    align-items: flex-end;
  }

  .footer-modal {
    display: flex;
  }

  .border-red {
    border: 1px solid red;
  }
}

// ! override
.btn-filter {
  width: 100%;

  &.add {
    max-width: 100px;
    width: 100%;
  }

  &.gold {
    background: var(--secondary-color);
    color: white !important;
    border-color: transparent !important;
  }
}
</style>
